import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Checkbox } from "@faire/web/slate/Checkbox";
import { getSpacing } from "@faire/web/slate/spacing";
import React from "react";
import styled from "styled-components";
import { CSAT_REASONS } from "./csatReasons";
export var ReasonsChecklist = function ReasonsChecklist(_ref) {
  var checked = _ref.checked,
    setChecked = _ref.setChecked;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var toggleReason = function toggleReason(reason) {
    if (checked.includes(reason)) {
      setChecked(checked.filter(function (reasonInList) {
        return reasonInList !== reason;
      }));
    } else {
      setChecked([].concat(_toConsumableArray(checked), [reason]));
    }
  };
  return /*#__PURE__*/React.createElement("div", null, CSAT_REASONS(strictLocalize).map(function (_ref2) {
    var id = _ref2.id,
      label = _ref2.label;
    return /*#__PURE__*/React.createElement(Reason, {
      key: id
    }, /*#__PURE__*/React.createElement(Checkbox, {
      label: label,
      checked: checked.includes(id),
      onChange: function onChange() {
        return toggleReason(id);
      }
    }));
  }));
};
var Reason = styled.div.withConfig({
  displayName: "ReasonsChecklist__Reason"
})(["margin:", " 0;input{opacity:0;}"], getSpacing("1x"));